import React from 'react';
import classNames from 'classnames';

import './Toast.scss';
import Icon from '../Icon';

const Toast = ({
  actions,
  color,
  message,
}) => (
  <div
    className={
      classNames(
        'toast', {
          [`toast--${color}`]: color,
        }
      )
    }
  >
    <div className="toast__content">
      <div>
        <div className="toast__icon">
          <Icon
            glyph="exclamation"
            weight="solid"
          />
        </div>
      </div>
      <div className="toast__message">
        {message}
      </div>
    </div>
    {actions && (
      <div className="toast__actions">
        {actions}
      </div>
    )}
  </div>
);

export default Toast;